<template>
  <span
    class="sj-icon"
    :class="[`icon-theme-${theme}`, { disabled }]"
    :style="{
      width: `${size}px`,
      height: `${size}px`
    }"
    v-on="$listeners"
  >
    <i v-if="!imgSrc" :class="[fontFamily, iconClass]" :style="iconStyle" />
    <img
      v-else
      :src="imgSrc"
      :style="{ width: `${iconSize}px`, height: `${iconSize}px` }"
    />
  </span>
</template>

<script>
export default {
  name: "SjIcon",
  props: {
    theme: {
      type: String,
      default: "1" //
    },
    fontFamily: {
      type: String,
      default: "icon_com"
    },
    iconClass: String,
    size: {
      type: Number,
      default: 20
    },
    iconSize: {
      type: Number,
      default: 14
    },
    imgSrc: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconStyle() {
      let size = this.iconSize;
      const style = {};
      if (size < 12) {
        style.transform = `scale(${(size / 12).toFixed(2)})`;
        style.transformOrigin = `center`;
        size = 12;
      }
      style.fontSize = `${size}px`;
      style.lineHeight = `${size}px`;
      return style;
    }
  },
  data() {
    return {
      hover: false
    };
  },
  methods: {}
};
</script>

<style scoped lang="less">
.sj-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: @base-border-radius;

  &.icon-theme-1 {
    i {
      color: @color-normal;
    }
    &:not(.disabled) {
      &:hover,
      &:active {
        i {
          color: @color-highlight;
        }
      }
    }
  }

  &.icon-theme-2 {
    i {
      color: @color-normal;
    }
    &:not(.disabled) {
      &:hover,
      &:active {
        i {
          color: @color-available;
        }

        background-color: @color-gray-3;
      }
    }
  }

  &.icon-theme-3 {
    i {
      color: @color-available;
    }
    &:not(.disabled) {
      &:hover,
      &:active {
        i {
          color: @color-highlight;
        }

        background-color: @color-gray-3;
      }
    }
  }

  &.icon-theme-4 {
    i {
      color: @color-highlight;
    }
    &:not(.disabled) {
      &:hover,
      &:active {
        i {
          color: @color-highlight;
        }

        background-color: @color-gray-3;
      }
    }
  }

  &.disabled {
    cursor: not-allowed;
    i {
      color: @color-light;
    }
  }
}
</style>
